export default "__VITE_ASSET__adc98a5f__"